export default __webpack_public_path__ + "static/media/a56ff916-35d5-402d-bc18-cd749869a0fe.737d5cb7.png";